export const languages = {
  multi: "Multilingual (Spanish + English)",
  bg: "Bulgarian",
  ca: "Catalan",
  zh: "Chinese (Mandarin, Simplified)",
  "zh-TW": "Chinese (Mandarin, Traditional)",
  "zh-HK": "Chinese (Cantonese, Traditional)",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  en: "English",
  et: "Estonian",
  fi: "Finnish",
  "nl-BE": "Flemish",
  fr: "French",
  de: "German",
  "de-CH": "German (Switzerland)",
  el: "Greek",
  hi: "Hindi",
  hu: "Hungarian",
  id: "Indonesian",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  lv: "Latvian",
  lt: "Lithuanian",
  ms: "Malay",
  no: "Norwegian",
  pl: "Polish",
  pt: "Portuguese",
  ro: "Romanian",
  ru: "Russian",
  sk: "Slovak",
  es: "Spanish",
  sv: "Swedish",
  th: "Thai",
  tr: "Turkish",
  uk: "Ukrainian",
  vi: "Vietnamese",
};

// https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/supported-languages/
export const supportedWhatsappLanguages = [
  { label: "Afrikaans", code: "af" },
  { label: "Albanian", code: "sq" },
  { label: "Arabic", code: "ar" },
  { label: "Arabic (EGY)", code: "ar_EG" },
  { label: "Arabic (UAE)", code: "ar_AE" },
  { label: "Arabic (LBN)", code: "ar_LB" },
  { label: "Arabic (MAR)", code: "ar_MA" },
  { label: "Arabic (QAT)", code: "ar_QA" },
  { label: "Azerbaijani", code: "az" },
  { label: "Belarusian", code: "be_BY" },
  { label: "Bengali", code: "bn" },
  { label: "Bengali (IND)", code: "bn_IN" },
  { label: "Bulgarian", code: "bg" },
  { label: "Catalan", code: "ca" },
  { label: "Chinese (CHN)", code: "zh_CN" },
  { label: "Chinese (HKG)", code: "zh_HK" },
  { label: "Chinese (TAI)", code: "zh_TW" },
  { label: "Croatian", code: "hr" },
  { label: "Czech", code: "cs" },
  { label: "Danish", code: "da" },
  { label: "Dari", code: "prs_AF" },
  { label: "Dutch", code: "nl" },
  { label: "Dutch (BEL)", code: "nl_BE" },
  { label: "English", code: "en" },
  { label: "English (UK)", code: "en_GB" },
  { label: "English (US)", code: "en_US" },
  { label: "English (UAE)", code: "en_AE" },
  { label: "English (AUS)", code: "en_AU" },
  { label: "English (CAN)", code: "en_CA" },
  { label: "English (GHA)", code: "en_GH" },
  { label: "English (IRL)", code: "en_IE" },
  { label: "English (IND)", code: "en_IN" },
  { label: "English (JAM)", code: "en_JM" },
  { label: "English (MYS)", code: "en_MY" },
  { label: "English (NZL)", code: "en_NZ" },
  { label: "English (QAT)", code: "en_QA" },
  { label: "English (SGP)", code: "en_SG" },
  { label: "English (UGA)", code: "en_UG" },
  { label: "English (ZAF)", code: "en_ZA" },
  { label: "Estonian", code: "et" },
  { label: "Filipino", code: "fil" },
  { label: "Finnish", code: "fi" },
  { label: "French", code: "fr" },
  { label: "French (BEL)", code: "fr_BE" },
  { label: "French (CAN)", code: "fr_CA" },
  { label: "French (CHE)", code: "fr_CH" },
  { label: "French (CIV)", code: "fr_CI" },
  { label: "French (MAR)", code: "fr_MA" },
  { label: "Georgian", code: "ka" },
  { label: "German", code: "de" },
  { label: "German (AUT)", code: "de_AT" },
  { label: "German (CHE)", code: "de_CH" },
  { label: "Greek", code: "el" },
  { label: "Gujarati", code: "gu" },
  { label: "Hausa", code: "ha" },
  { label: "Hebrew", code: "he" },
  { label: "Hindi", code: "hi" },
  { label: "Hungarian", code: "hu" },
  { label: "Indonesian", code: "id" },
  { label: "Irish", code: "ga" },
  { label: "Italian", code: "it" },
  { label: "Japanese", code: "ja" },
  { label: "Kannada", code: "kn" },
  { label: "Kazakh", code: "kk" },
  { label: "Kinyarwanda", code: "rw_RW" },
  { label: "Korean", code: "ko" },
  { label: "Kyrgyz (Kyrgyzstan)", code: "ky_KG" },
  { label: "Lao", code: "lo" },
  { label: "Latvian", code: "lv" },
  { label: "Lithuanian", code: "lt" },
  { label: "Macedonian", code: "mk" },
  { label: "Malay", code: "ms" },
  { label: "Malayalam", code: "ml" },
  { label: "Marathi", code: "mr" },
  { label: "Norwegian", code: "nb" },
  { label: "Pashto", code: "ps_AF" },
  { label: "Persian", code: "fa" },
  { label: "Polish", code: "pl" },
  { label: "Portuguese (BR)", code: "pt_BR" },
  { label: "Portuguese (POR)", code: "pt_PT" },
  { label: "Punjabi", code: "pa" },
  { label: "Romanian", code: "ro" },
  { label: "Russian", code: "ru" },
  { label: "Serbian", code: "sr" },
  { label: "Sinhala", code: "si_LK" },
  { label: "Slovak", code: "sk" },
  { label: "Slovenian", code: "sl" },
  { label: "Spanish", code: "es" },
  { label: "Spanish (ARG)", code: "es_AR" },
  { label: "Spanish (CHL)", code: "es_CL" },
  { label: "Spanish (COL)", code: "es_CO" },
  { label: "Spanish (CRI)", code: "es_CR" },
  { label: "Spanish (DOM)", code: "es_DO" },
  { label: "Spanish (ECU)", code: "es_EC" },
  { label: "Spanish (HND)", code: "es_HN" },
  { label: "Spanish (MEX)", code: "es_MX" },
  { label: "Spanish (PAN)", code: "es_PA" },
  { label: "Spanish (PER)", code: "es_PE" },
  { label: "Spanish (SPA)", code: "es_ES" },
  { label: "Spanish (URY)", code: "es_UY" },
  { label: "Swahili", code: "sw" },
  { label: "Swedish", code: "sv" },
  { label: "Tamil", code: "ta" },
  { label: "Telugu", code: "te" },
  { label: "Thai", code: "th" },
  { label: "Turkish", code: "tr" },
  { label: "Ukrainian", code: "uk" },
  { label: "Urdu", code: "ur" },
  { label: "Uzbek", code: "uz" },
  { label: "Vietnamese", code: "vi" },
  { label: "Zulu", code: "zu" },
];
